<!-- 新建/编辑 本地图文模板 的 插入小程序 -->
<template>
<a-modal
	  :title="`插入小程序`"
	  :visible="visible"
	  :confirm-loading="confirmLoading"
	  cancelText="取消"
	  okText="确认" 
	  width="800px" 
	  @ok="modalOk"
	  @cancel="modalCancel"
	  
	>
	
	<div class="form-cell-box">
		<div class="class-title" >小程序APPID</div>
		
		<div>会自动获取</div>
	</div>
	
	<div class="form-cell-box">
		<div class="class-title" >小程序路径</div>
		
		<a-select
			show-search
			style="width: 550px;"
			placeholder="请选择小程序路径"
			@change="handleChangeA"
			:filter-option="filterOption"
			:getPopupContainer="getsPopupContainer"
			:value="path_url"
		  >
			<a-select-option v-for="(value,key) in pathSelecr" :key="key" :value="key" :title="key">
			  {{value}}（{{key}}）
			</a-select-option>
		</a-select>
	</div>
	
	<div class="form-cell-box">
		<div class="class-title" >展示方式</div>
		
		<a-radio-group name="radioGroup" :value="show_type" @change="radioChangeA"  style="display: flex;">
		    <a-radio value="1">
				文字
		    </a-radio>
		    <a-radio value="2">
				图片
		    </a-radio>
		    <a-radio value="3">
				小程序卡片
		    </a-radio>
		</a-radio-group>
	</div>
	
	<div v-if="show_type == '1'" class="form-cell-box">
		<div class="class-title" >文字内容</div>
		
		<a-input v-model="r_xcx_text" placeholder="请输入文字内容" allowClear style="width: 550px;"/>
	</div>
	
	<div v-else-if="show_type == '2'" class="form-cell-box" style="align-items: baseline;">
		<div class="class-title" >图片</div>
		
		<div style="color: #7e8081;">
			<div>点击图片会打开小程序指定路径的页面。图片规格不限,大小限制为1M</div>
			<div style="margin-top: 8px;display: flex;align-items: center;">
				<a-upload
				    name="file"
				    :multiple="true"
				    action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
				    :headers="headers"
				    @change="handleChangeUpload"
				  >
				    <a-button> 上传图片 </a-button>
				</a-upload>
				
				<a-button style="margin-left: 12px;"> 从图片库选择 </a-button>
			</div>
		</div>
	</div>
	
	<template v-else-if="show_type == '3'">
	<div class="form-cell-box" style="align-items: baseline;">
		<div class="class-title" >卡片标题</div>
		
		<div>
			<a-input v-model="r_xcx_title" placeholder="请输入文字内容" allowClear style="width: 550px;"/>
			<div style="color: #7e8081;margin-top: 8px;">点击小程序卡片会打开小程序路径指定的页面</div>
		</div>
	</div>
	
	<div class="form-cell-box">
		<div class="class-title" >卡片样式</div>
		
		<div style="width: 272px;position: relative;background-color: #f6f7f8;border: 1px solid #e3e4e5;border-radius: 2px;">
			<div style="padding: 10px 15px 15px;">
				<div style="display: flex;align-items: center;">
					<div style="width: 20px;height: 20px;display: flex;align-items: center;justify-content: center;border: 1px solid #e3e4e5;border-radius: 50%;">
						<img src="../../../../assets/xcx-icon.png" style="width: 16px;"/>
					</div>
					<div style="margin-left: 10px;">小程序名字</div>
				</div>
				<div style="padding: 5px 0 10px;">{{r_xcx_title}}</div>
				<div style="width: 240px;height: 180px;border: 1px dashed #e3e4e5;text-align: center;padding: 20px 0;box-sizing: border-box;background-color: #fff;position: relative;">
					<div style="margin-bottom: 10px;padding: 0 10px 10px;color: #7e8081;word-break: break-word;">建议图片尺寸为5:4，大小不超过1M，暂不支持动图。</div>
					<a-upload
					    name="file"
					    :multiple="true"
					    action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
					    :headers="headers"
					    @change="handleChangeUpload"
					  >
					    <a-button> 上传图片 </a-button>
					</a-upload>
					<a-button style="margin-top: 7px;"> 从图片库选择 </a-button>
				</div>
			</div>
			<div style="padding: 0 15px;border-top: 1px solid #e3e4e5;line-height: 24px;display: flex;align-items: center;">
				<img src="../../../../assets/xcx-icon.png" style="width: 14px;"/>
				
				<span style="margin-left: 10px;font-size: 14px;">小程序</span>
			</div>
		</div>
	</div>
	</template>
</a-modal>
</template>

<script>
import { getBookOftenLink } from '@/request/api'
export default {
	name: 'xcxLink_',
	props: [],
	data(){
		return {
			visible: false,
			confirmLoading: false,
			
			pathSelecr: {},
			path_url: undefined,
			
			show_type: "1",
			
			headers: {
			    authorization: 'authorization-text',
			},
			
			r_xcx_text: null, // 小程序文字内容
			r_xcx_title: null, // 小程序卡片标题
		}
	},
	methods: {
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		handleChangeA(e){
			this.path_url = e
		},
		showModal(){
			let that = this
			getBookOftenLink().then(res=>{
				console.log("乐读书城常用地址下拉",res);
				that.pathSelecr = res.data['xs']
				that.visible = true
				
			})
		},
		modalOk(){
			let that = this
			if(!that.path_url){
				that.$message.warning("请选择小程序路径")
			}
			else if(that.show_type == 1 && !that.r_xcx_text){
				that.$message.warning("请输入文字内容")
			}
			else if(that.show_type == 2 && !that.r_xcx_text){
				that.$message.warning("请选择上传的图片")
			}
			let obj = {
				show_type: that.show_type,
				path_url: that.path_url,
				xcx_text: that.r_xcx_text,
			}
			this.$emit("modal-ok", obj)
		},
		modalCancel(){
			this.visible = false
		},
		
		radioChangeA(e){
			console.log("e",e.target.value);
			this.show_type = e.target.value
		},
		handleChangeUpload(info){
			if (info.file.status !== 'uploading') {
			    console.log(info.file, info.fileList);
			}
			if (info.file.status === 'done') {
			    this.$message.success(`${info.file.name} file uploaded successfully`);
			} else if (info.file.status === 'error') {
			    this.$message.error(`${info.file.name} file upload failed.`);
			}
		},
	}
}
</script>

<style>
</style>